import Transform from "@ember-data/serializer/transform";
import type { FormattedDay } from "parog-web/utils/group-by-day";

export default class DateOnlyTransform extends Transform {
  /**
  Make sure the date string "yyyy-mm-dd" we receive from the back are converted to dates
  without using the browser's current timezone

  Example when run in a browser in France UTC+1
  new Date("2025-01-01") # => Wed Jan 01 2025 01:00:00 GMT+0100 (heure normale d’Europe centrale)

  Example when run in a browser in Martinique UTC-4
  new Date("2025-01-01") # => Tue Dec 31 2024 20:00:00 GMT-0400 (heure normale de l’Atlantique)

  As you can see, the day, month and year changed due to timezone conversion

  To avoid this, we deserialize the date string by forcing the time to "00:00", hence making
  sure we the date is not timezone dependend

  new Date("2025-01-01T00:00:00") # => Wed Jan 01 2025 00:00:00 GMT-0400 (heure normale de l’Atlantique)
  */
  override deserialize(serialized: FormattedDay | null): Date | null {
    return serialized ? new Date(`${serialized}T00:00:00`) : null;
  }

  override serialize(deserialized: Date | null): Date | null {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "date-only": DateOnlyTransform;
  }
}
